document.addEventListener('DOMContentLoaded', function () {
    const discountMap = {
      '20OFFLTO': 0.20, // 20% off
      // Add other codes here
    };

    let originalOnetimeHTML = null;
    let activeDiscountPercent = 0; // Global state to prevent unnecessary API calls
    let isFetching = false; // Lock to prevent overlapping calls

    async function updateStorefrontPrices() {
      if (isFetching) return;
      isFetching = true;

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        let activeCode = null;

        // 1. Check Cart-Level Discounts
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            activeCode = cart.cart_level_discount_applications[0].title; 
        } 
        
        // 2. Check Line-Item Discounts (Abra Fix)
        if (!activeCode && cart.items && cart.items.length > 0) {
            for (let i = 0; i < cart.items.length; i++) {
                const item = cart.items[i];
                if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
                    activeCode = item.line_level_discount_allocations[0].discount_application?.title;
                    if (activeCode) break; 
                }
            }
        }

        // 3. Fallback to Cookie
        if (!activeCode && cart.item_count === 0) {
            const cookieMatch = document.cookie.match('(^|;)\\s*discount_code\\s*=\\s*([^;]+)');
            if (cookieMatch) {
                activeCode = decodeURIComponent(cookieMatch.pop());
            }
        }

        if (activeCode) activeCode = activeCode.toUpperCase();

        activeDiscountPercent = discountMap[activeCode] || 0;

        // 4. LOGIC: Revert or Apply
        if (activeDiscountPercent === 0) {
          revertPrices();
        } else {
          applyMainPriceDiscount(activeDiscountPercent);
          applyRechargeDiscount(activeDiscountPercent);
        }

      } catch (error) {
        console.error('Price Striker Error:', error);
      } finally {
        isFetching = false;
      }
    }

    function applyMainPriceDiscount(percent) {
      document.querySelectorAll('.price').forEach(priceContainer => {
        const regularPriceEl = priceContainer.querySelector('.price__regular .price-item--regular');
        const salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
        const struckEl = priceContainer.querySelector('.price__sale s.price-item--regular');

        if (!regularPriceEl || !salePriceEl || !struckEl) return;

        if (!priceContainer.dataset.originalHtml) {
            priceContainer.dataset.originalHtml = priceContainer.innerHTML;
        }

        const originalText = regularPriceEl.textContent.trim();
        const priceMatch = originalText.match(/\$([0-9.,]+)/);

        if (priceMatch) {
          const rawPrice = parseFloat(priceMatch[1].replace(/,/g, ''));
          const newPrice = (rawPrice * (1 - percent)).toFixed(2);
          
          const newText = originalText.replace('$' + priceMatch[1], '$' + newPrice);

          struckEl.textContent = originalText; 
          salePriceEl.textContent = newText;
          
          priceContainer.classList.add('price--on-sale');
          priceContainer.classList.remove('price--no-compare');
        }
      });
    }

    function applyRechargeDiscount(percent) {
      const onetimeLabel = document.querySelector('.onetime-radio .rc-radio__label');
      
      if (!onetimeLabel) return;

      if (!originalOnetimeHTML && !onetimeLabel.getAttribute('data-discounted')) {
          originalOnetimeHTML = onetimeLabel.innerHTML;
      }
      
      if (!onetimeLabel.getAttribute('data-discounted')) {
        const originalText = onetimeLabel.textContent; 
        const priceMatch = originalText.match(/\$(\d+\.\d+)/);
        
        if (priceMatch) {
          const originalPrice = parseFloat(priceMatch[1]);
          const discountedPrice = (originalPrice * (1 - percent)).toFixed(2);
          
          onetimeLabel.innerHTML = `<div style="display: flex;justify-content: space-between;width: 100%;"> <span>One-time purchase</span> <div><s style="color: #999;margin-right: 5px;">$${originalPrice.toFixed(2)}</s> <span>$${discountedPrice}</span></div></div>`;
          onetimeLabel.setAttribute('data-discounted', 'true');
        }
      }
    }

    function revertPrices() {
      document.querySelectorAll('.price').forEach(priceContainer => {
        if (priceContainer.dataset.originalHtml && priceContainer.classList.contains('price--on-sale')) {
          priceContainer.innerHTML = priceContainer.dataset.originalHtml;
          priceContainer.classList.remove('price--on-sale');
          priceContainer.classList.add('price--no-compare');
          delete priceContainer.dataset.originalHtml;
        }
      });
      
      const onetimeLabel = document.querySelector('.onetime-radio .rc-radio__label');
      if (onetimeLabel && onetimeLabel.getAttribute('data-discounted') && originalOnetimeHTML) {
        onetimeLabel.innerHTML = originalOnetimeHTML;
        onetimeLabel.removeAttribute('data-discounted');
      }
    }

    // --- SAFELY INTERCEPT FETCH REQUESTS ---
    const originalFetch = window.fetch;
    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);
      const url = arguments[0];
      
      // ONLY trigger on cart mutations, NOT on normal GET requests to /cart.js
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear') || url.includes('discount'))) {
          setTimeout(updateStorefrontPrices, 750);
      }
      return response;
    };

    // --- SAFELY INTERCEPT XHR REQUESTS ---
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
        this.addEventListener('load', function() {
            if (this.responseURL.includes('/cart/add') || this.responseURL.includes('/cart/change') || this.responseURL.includes('/cart/update') || this.responseURL.includes('/cart/clear') || this.responseURL.includes('discount')) {
                setTimeout(updateStorefrontPrices, 750);
            }
        });
        origOpen.apply(this, arguments);
    };

    // Initial Run
    updateStorefrontPrices();
    
    // --- SAFELY OBSERVE RECHARGE WIDGET ---
    let observerDebounce;
    const observer = new MutationObserver(() => {
      const label = document.querySelector('.onetime-radio .rc-radio__label');
      if (label && !label.getAttribute('data-discounted') && !originalOnetimeHTML) {
          clearTimeout(observerDebounce);
          observerDebounce = setTimeout(() => {
             // Just apply the visual update using the saved percent, DO NOT call the API again here!
             if (activeDiscountPercent > 0) {
                 applyRechargeDiscount(activeDiscountPercent);
             }
          }, 100);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });